import styled from 'styled-components';
import type { InsightBlock, InsightTheme } from '../types';
import CalloutBlock from './blocks/CalloutBlock';
import DividerBlock from './blocks/DividerBlock';
import HeadingBlock from './blocks/HeadingBlock';
import ImageBlock from './blocks/ImageBlock';
import InternalCtaBlock from './blocks/InternalCtaBlock';
import ListBlock from './blocks/ListBlock';
import ParagraphBlock from './blocks/ParagraphBlock';
import PullQuoteBlock from './blocks/PullQuoteBlock';

const Stack = styled.div`
  display: grid;
  gap: 1.7rem;
`;

type BlockRendererProps = {
  blocks: InsightBlock[];
  theme: InsightTheme;
};

export default function BlockRenderer({ blocks, theme }: BlockRendererProps) {
  return (
    <Stack>
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;
        switch (block.type) {
          case 'heading':
            return <HeadingBlock key={key} block={block} accent={theme.accent} ink={theme.ink} />;
          case 'paragraph':
            return <ParagraphBlock key={key} block={block} ink={theme.ink} mutedInk={theme.mutedInk} />;
          case 'image':
            return <ImageBlock key={key} block={block} accent={theme.accent} surface={theme.surface} />;
          case 'callout':
            return <CalloutBlock key={key} block={block} accent={theme.accent} />;
          case 'internalCta':
            return <InternalCtaBlock key={key} block={block} accent={theme.accent} />;
          case 'pullQuote':
            return <PullQuoteBlock key={key} block={block} accent={theme.accent} ink={theme.ink} />;
          case 'divider':
            return <DividerBlock key={key} accent={theme.accent} />;
          case 'list':
            return (
              <ListBlock
                key={key}
                block={block}
                accent={theme.accent}
                ink={theme.ink}
                mutedInk={theme.mutedInk}
              />
            );
          default:
            return null;
        }
      })}
    </Stack>
  );
}
